import _regeneratorRuntime from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import infoList from "@/mixins/infoList";
import { emailSendLog } from "@/api/data";
import { getUserInfoMap } from "@/utils/dictionary";
import DataOptions from "../../components/timeList/dataOptions.vue";
export default {
  mixins: [infoList],
  components: {
    DataOptions: DataOptions
  },
  data: function data() {
    return {
      listApi: emailSendLog,
      UserInfoList: "",
      formTime: [this.$moment().subtract(7, "days").format("YYYY-MM-DD"), this.$moment().format("YYYY-MM-DD")],
      searchInfo: {},
      dialogFormVisible: false,
      type: "",
      value: "",
      deleteVisible: false,
      multipleSelection: [],
      //操作类型
      oper_type: 1,
      apply_id: "",
      approve_id: "",
      //操作类型下拉框
      options: [{
        label: "申请邮件",
        value: 1
      }, {
        label: "修改邮件",
        value: 2
      }, {
        label: "审批邮件",
        value: 3
      }, {
        label: "发送邮件",
        value: 4
      }]
    };
  },
  filters: {
    formatBoolean: function formatBoolean(bool) {
      if (bool != null) {
        return bool ? "是" : "否";
      } else {
        return "";
      }
    }
  },
  created: function created() {
    this.init();
  },
  methods: {
    init: function init() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getUserInfoMap();
            case 2:
              res = _context.sent;
              _this.UserInfoList = res;
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    open2: function open2() {
      this.$notify({
        title: "邮件发送日志",
        message: "（1）记录邮件申请、审批、发送的日志。" + "(2)支持按时间、申请人员Id、审批人员Id、查询<。" + "(3)默认显示最近20条邮件记录",
        duration: 0
      });
    },
    //点击了选择改变按钮
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    onSubmit: function onSubmit() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this2.searchInfo.sdate = _this2.formTime[0];
              _this2.searchInfo.edate = _this2.formTime[1];
              _this2.searchInfo.apply_id = _this2.apply_id;
              _this2.searchInfo.approve_id = _this2.approve_id;
              _this2.searchInfo.operation = _this2.oper_type;
              _context2.next = 7;
              return _this2.getTableData();
            case 7:
              if (_this2.tableData.length === 0) {
                _this2.$message({
                  message: "暂无数据"
                });
              }
            case 8:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    } //批量删除按钮
    /*onDelete() {
        alert("批量删除还没做");
        const ids = [];
        this.multipleSelection && this.multipleSelection.map(item => {
            ids.push(item.ID);
        });
        const res = await .....({ ids });
        if (res.code == 0) {
            this.$message({
            type: "success",
            message: "删除成功"
            });
            if (this.tableData.length == ids.length) {
            this.page--;
            }
            this.deleteVisible = false;
            this.getTableData();
        }
      },*/
    //删除单行
    /*
    deleteSysOperationRecord(row) {
        alert("删除一行还没做");
        row.visible = false;
        todo  调用单独删除接口
        const res = await .....({ ID: row.ID });
        if (res.code == 0) {
            this.$message({
            type: "success",
            message: "删除成功"
            });
            if (this.tableData.length == 1) {
                this.page--;
            }
                this.getTableData();
        }
        },
    },
    */
  }
};